/**
 * Configuration for the embedded UAssist (`<uassist-chat>`) chat widget.
 *
 * The widget is a third-party web component loaded from `widgetScriptUrl`. It talks
 * to the same backend UPC uses; `apiUrl`/`tenant`/`agentName` are passed to the
 * element as attributes and the widget owns the transport (same-origin `/api`, so
 * the workspace CSRF interceptor + session cookie apply automatically).
 *
 * `agentName` is wired to the UPC agent for now (known to exist); swap to a
 * dedicated `workspace-assistant` agent once provisioned.
 */
export const AiAssistantConfig = {
    /**
     * URL of the UAssist widget IIFE script to load once.
     */
    widgetScriptUrl: 'https://beacon.ingress.aidash.atom-dev.shoot.canary.k8s-hana.ondemand.com/dist/uassist-widget.iife.js',

    /**
     * Same-origin API base for the assistant service (proxied to the backend).
     */
    apiUrl: '/api/cloudAutomationDesigner/assistant',

    /**
     * Tenant identifier.
     */
    tenant: 'sap-cfs',

    /**
     * Agent name. Wired to the UPC agent for now; swap to 'workspace-assistant'
     * when that agent is provisioned on the backend.
     */
    agentName: 'upc-assistant',

    /**
     * Accent color passed to the widget (matches the workspace highlight).
     */
    accentColor: '#0668AE',

    /**
     * Main chat background color passed to the widget (matches the workspace
     * dark panel surface).
     */
    backgroundColor: '#32353A',

    /**
     * User message bubble color (widget `user-accent-color`).
     */
    userBubbleColor: '#292B30',

    /**
     * Assistant response card background. The widget hardcodes this card as the
     * Tailwind class `dark:bg-gray-900` with no attribute/CSS var, so it is
     * overridden by injecting a stylesheet into the widget shadow root.
     */
    responseCardColor: '#272A2C'
};
